import { schema } from 'normalizr';

export const categorySchema = new schema.Entity('category', {}, { idAttribute: '_id' });
export const categoryListSchema = [categorySchema];
